import React from 'react';
import { motion } from 'framer-motion';

const items = [
  'The ceremony space', 'The terrace', 'The ballroom', 'The food', 'The views',
  'The staff', 'The atmosphere', 'The photo spots', 'How your guests felt', 'Your favorite memory'
];

const WhatToMention = () => {
  return (
    <section className="w-full bg-padua-lightSage/30 border border-padua-sage/10 rounded-3xl p-8 md:p-12">
      <div className="text-center mb-10">
        <h3 className="font-serif text-2xl md:text-3xl text-padua-dark mb-2">What You Can Mention</h3>
        <div className="w-12 h-px bg-padua-gold/40 mx-auto mt-4"></div>
      </div>
      
      <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto">
        {items.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.05 }}
            className="bg-white px-4 py-2 rounded-full border border-padua-sage/20 text-padua-olive text-sm md:text-base font-medium shadow-sm hover:border-padua-gold/50 transition-colors"
          >
            {item}
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhatToMention;